import { serialize } from '@/services/UtilityService';
import ApiFactory from '@/factories/ApiFactory';

const checkIfCustomerExists = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`posB2B/v1/customer-exists?${query}`).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

export default {
	checkIfCustomerExists,
};
